import { Statistic, Typography, Space, theme } from "antd";
import React from "react";
import BusinessTable from "./components/Business-Table/BusinessTable";
import BusinessesActionMenu from "./components/Businesses-Action-Menu/BusinessesActionMenu";
import GeneralTableHeader from "../common/general-table-header/GeneralTableHeader";
import { useAppSelector } from "../../app/hooks";
import {
  selectIsLoadingBusinesses,
  selectTotalBusinessCount,
} from "./businessesSlice";
import { ShopOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export default function Businesses() {
  const totalCount = useAppSelector(selectTotalBusinessCount);
  const loading = useAppSelector(selectIsLoadingBusinesses);
  const { token } = theme.useToken();

  return (
    <div>
      <GeneralTableHeader
        title="Business Manager"
        extra={[<BusinessesActionMenu key="actions" />]}
        statisticsCount={totalCount}
        statisticsLabel="Amount of Merchants"
        statisticsLoading={loading}
        description="A list of all of Klearly's merchants."
        avatarUrl={<ShopOutlined style={{ fontSize: "30px" }} />}
        // put K
      ></GeneralTableHeader>
      <BusinessTable />
    </div>
  );
}
